import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { selectPickupPoint } from '../../../actions.js';
import { getSelectedPickupPoint } from '../../../selectors.js';
import { PickupPointsFinderContainer } from './PickupPointsFinderContainer.js';
import { PickupLocationInformation } from '../components/PickupLocationInformation.js';
import { PickupWarningMessage } from '../components/PickupWarningMessage.js';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';

const PickupPointsContainer = ({ hideTitle =false , warningMessageOnly =false  })=>{
    const { getLabel  } = useIntl();
    const { itemsToBeShipped  } = useCheckoutSettings();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const dispatch = useDispatch();
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const onPickupPointSelect = (pickupPoint)=>{
        if (!pickupPoint) {
            return;
        }
        dispatch(selectPickupPoint({
            pickupPoint
        }));
        setModalIsOpen(false);
    };
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    React.useEffect(()=>{
        if (!selectedPickupPoint) {
            setModalIsOpen(true);
        }
    }, [
        selectedPickupPoint
    ]);
    const labels = React.useMemo(()=>({
            error: getLabel('checkout.pickupPoints.error'),
            noSelection: getLabel('checkout.pickupPoints.selectPoint.message'),
            noSelectionLink: getLabel('checkout.pickupPoints.selectPoint.link'),
            title: getLabel('checkout.pickupPoints.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, modalIsOpen && /*#__PURE__*/ React.createElement(Modal, {
        className: "checkout-step--shipping__modal",
        showIcon: true,
        iconClassName: "checkout-step--shipping__modal__close",
        isOpen: modalIsOpen,
        onModalClose: onPickupModalClose
    }, /*#__PURE__*/ React.createElement(PickupPointsFinderContainer, {
        onPickupPointSelect: onPickupPointSelect,
        errorMessage: labels.error,
        itemsToBeShipped: itemsToBeShipped
    })), selectedPickupPoint && !warningMessageOnly ? /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        hideTitle: hideTitle,
        title: labels.title,
        location: selectedPickupPoint,
        onPickupModalShow: onPickupModalShow
    }) : /*#__PURE__*/ React.createElement(PickupWarningMessage, {
        labels: labels,
        onPickupModalShow: onPickupModalShow
    }));
};

export { PickupPointsContainer };
//# sourceMappingURL=PickupPointsContainer.js.map
